
import { Placement } from '@post-office/placements-frontend/jsm-responders-update';
export default Placement;
